import {getWidthHeight} from '@/services/utility';
import {DatePicker, DateTimePicker} from 'react-advance-jalaali-datepicker';
import {Platform} from 'react-native';
import SelectBox from 'react-native-multi-selectbox';
import {TextInput} from 'react-native-web';
import styled from 'styled-components';
const CommonTextInputStyle = {
  border: '1px solid',
  borderRadius: 5,
  padding: 10,
  fontFamily: 'IRANSans',
};
const CommonTextInputStyleAndroid = {
  ...CommonTextInputStyle,
};
export const CommonTextInputStyleWeb = {
  ...CommonTextInputStyle,
  direction: 'rtl',
  display: 'block',
  flexDirection: 'row',
};
export const CommonHalfTextInputStyleWeb = {
  ...CommonTextInputStyle,
  direction: 'rtl',
  flexDirection: 'row',
};
export const CommonTextInputElem = styled(TextInput)``;
export const CommonSelectElem = styled(SelectBox)`
  ${CommonTextInputStyleAndroid}
`;
export const CommonDatePickerElem = styled(DateTimePicker)`
  ${CommonTextInputStyleAndroid}
`;
export const CommonJustDatePickerElem = styled(DatePicker)`
  ${CommonTextInputStyleAndroid}
`;
export const calcInputWidth = (padding, isHalf, style) => {
  if (style.minWidth !== undefined) return;
  if (isHalf) {
    style.minWidth = isApp ? '50%' : 'calc(50% - ' + padding + 'px)';
    style.maxWidth = isApp ? '50%' : 'calc(50% - ' + padding + 'px)';
    return style;
  }
  const isApp = Platform.OS !== 'web';
  const width = getWidthHeight()[0];
  style.minWidth = isApp
    ? '100%'
    : width > 960
    ? 'calc(25% - ' + padding + 'px)'
    : width > 768
    ? 'calc(33% - ' + padding + 'px)'
    : width > 576
    ? 'calc(50% - ' + padding + 'px)'
    : '100%';
  return style;
};
